import Modal from './Modal'
import Cookies from 'js-cookie'

export default class ModalAlert extends Modal {
    constructor(element) {
        super(element)

        this.alertId = this.element.dataset.alertId
    }

    prepare() {
        super.prepare()

        const alertId = Cookies.get(`cookiesAlertDay-${this.alertId}`)

        if (!alertId || alertId !== this.alertId) {
            this.on('close', this.handleClose)
            this.open()
        }
    }

    handleClose = () => {
        Cookies.set(`cookiesAlertDay-${this.alertId}`, this.alertId, {
            expires: 1
        })
    }
}
